class StateGlobal
{
    static myInstance = null;

    /**
     * Singleton class
     */
    static getState()
    {
        if (StateGlobal.myInstance == null)
        {
            StateGlobal.myInstance = new StateGlobal();
        }
        return StateGlobal.myInstance;
    }

    static _nActiveReportReq = 0;
    static _bTemplateJustCreated = false;
    static _bRepoEntitiesNotActual = false;
    static _currentBradCrumbs = [];
    static _isModelSelected = false;
    static _isObjectSelected = false;
    static _modelSelected = "";
    static _objectSelected = "";
    static _currentRelDirection = "";

    constructor()
    {}

    static incActiveReportReq = () =>
    {
        StateGlobal._nActiveReportReq++;
    }
    static decActiveReportReq = () =>
    {
        if (0 < StateGlobal._nActiveReportReq)
        {
            StateGlobal._nActiveReportReq--;
        }
    }
    static getActiveReportReq = () =>
    {
        return StateGlobal._nActiveReportReq;
    }


    static setTemplateJustCreated = () =>
    {
        StateGlobal._bTemplateJustCreated = true;
    }
    static resetTemplateJustCreated = () =>
    {
        StateGlobal._bTemplateJustCreated = false;
    }
    static isTemplateJustCreated = () =>
    {
        return StateGlobal._bTemplateJustCreated;
    }

    static setRepoEntitiesNotActual = () =>
    {
        StateGlobal._bRepoEntitiesNotActual = true;
    }
    static resetRepoEntitiesNotActual = () =>
    {
        StateGlobal._bRepoEntitiesNotActual = false;
    }
    static isRepoEntitiesNotActual = () =>
    {
        return StateGlobal._bRepoEntitiesNotActual;
    }
}
export default StateGlobal;